import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { TranslateModule } from '@ngx-translate/core';

import { TwcModule } from '@topcon/twc-angular';

import { DirectivesModule } from '../../directives/directives.module';
import { UploadWizardService } from '../../services/upload-wizard-service/upload-wizard.service';
import { WorkflowWizardService } from '../../services/workflow/workflow-wizard.service';
import { Crp1ScanSelectModule } from '../crp1-scan-select/crp1-scan-select.module';
import { CrsSearchModule } from '../crs-search/crs-search.module';
import { InputFileModule } from '../input-file/input-file.module';
import { ObjectBrowserModule } from '../object-browser/object-browser.module';
import { ScanProcessingOptionsModule } from '../scan-processing-options/scan-processing-options.module';
import { SelectExistingLayerComponent } from '../select-existing-layer/select-existing-layer.component';
import { SelectExistingLayerModule } from '../select-existing-layer/select-existing-layer.module';
import { UploadListModule } from '../upload-list/upload-list.module';
import { ThreeDModelImportOptionsComponent } from './3d-model-import-options/3d-model-import-options.component';
import { CreateProjectWizardProjectDataComponent } from './create-project-wizard-project-data/create-project-wizard-project-data.component';
import { CreateWizardInputDataComponent } from './create-wizard-input-data/create-wizard-input-data.component';
import { CreateWizardSummaryComponent } from './create-wizard-summary/create-wizard-summary.component';
import { CreateWizardComponent } from './create-wizard.component';
import { GisImportOptionsComponent } from './gis-import-options/gis-import-options.component';
import { PointSelectorComponent } from './point-selector/point-selector.component';
import { PointSelectorService } from './point-selector/point-selector.service';
import { PointcloudImportOptionsComponent } from './pointcloud-import-options/pointcloud-import-options.component';
import { PopupNotValidFilesComponent } from './popup-not-valid-files/popup-not-valid-files.component';
import { SelectLayerComponent } from './select-layer/select-layer.component';
import { SelectNewLayerComponent } from './select-layer/select-new-layer/select-new-layer.component';
import { UavImportOptionsComponent } from './uav-import-options/uav-import-options.component';
import { WorkspaceComponent } from './workspace/workspace.component';
import { WorkspaceService } from './workspace/workspace.service';

@NgModule({
    declarations: [
        CreateWizardComponent,
        CreateWizardSummaryComponent,
        CreateWizardInputDataComponent,
        CreateProjectWizardProjectDataComponent,
        PointcloudImportOptionsComponent,
        PopupNotValidFilesComponent,
        UavImportOptionsComponent,
        ThreeDModelImportOptionsComponent,
        GisImportOptionsComponent,
        SelectLayerComponent,
        SelectNewLayerComponent,
        PointSelectorComponent,
        WorkspaceComponent,
    ],
    imports: [
        SelectExistingLayerModule,
        BrowserAnimationsModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TwcModule,
        TranslateModule.forChild({
            extend: true,
        }),
        InputFileModule,
        UploadListModule,
        CrsSearchModule,
        ObjectBrowserModule,
        DirectivesModule,
        ScanProcessingOptionsModule,
        Crp1ScanSelectModule,
    ],
    exports: [
        CreateWizardComponent,
        SelectNewLayerComponent,
        SelectExistingLayerComponent,
        CreateWizardInputDataComponent,
        CreateProjectWizardProjectDataComponent,
        CreateWizardSummaryComponent,
    ],
    providers: [UploadWizardService, PointSelectorService, WorkspaceService, WorkflowWizardService],
})
export class CreateWizardModule {}
